<template>
  <v-app>
    <v-app-bar app color="primary" dark>
      <div class="d-flex align-center">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          src="https://cdn.vuetifyjs.com/images/logos/vuetify-logo-dark.png"
          transition="scale-transition"
          width="40"
        />

        <v-img
          alt="Vuetify Name"
          class="shrink mt-1 hidden-sm-and-down"
          contain
          min-width="100"
          src="https://cdn.vuetifyjs.com/images/logos/vuetify-name-dark.png"
          width="100"
        />
      </div>

      <v-spacer></v-spacer>

      <v-btn href="/" text>
        <v-icon>mdi-home</v-icon>
        <span class="ml-2">HOME</span>
      </v-btn>

      <v-spacer></v-spacer>

      <v-btn href="/pharmacy" text>
        <v-icon>mdi-pill</v-icon>
        <span class="ml-2">PHARMACY</span>
      </v-btn>

      <v-spacer></v-spacer>

      <v-btn href="/about" text>
        <v-icon>mdi-information</v-icon>
        <span class="ml-2">ABOUT</span>
      </v-btn>

      <v-spacer></v-spacer>

      <v-btn v-on:click="logout" text>
        <span class="mr-2">LOGOUT</span>
        <v-icon>mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>

    <v-content>
      <v-container>
        <router-view />
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import firebase from "firebase/app";
import "firebase/firestore";

export default {
  name: "App",
  components: {},

  methods: {
    logout: function() {
      firebase.auth().signOut();
    }
  },

  data: () => ({
    //
  })
};
</script>
